// Prefetch dos chunks de rota para deep-links do MVF (auth.mvfContext.legacyNext).
//
// No fluxo embedded o app inicia em /started, roda a cadeia de bootstrap
// (auth -> dashboard -> apps -> permissões) e só então redireciona para o
// deep-link — o download do chunk da rota alvo começava apenas nesse momento.
// Disparar o mesmo import() da rota logo no mount do App sobrepõe o download
// dos chunks às chamadas de bootstrap.
//
// Os loaders usam exatamente os mesmos specifiers das rotas (App.js,
// pages/*/listRoutes.js), então o webpack resolve para os mesmos chunks e o
// react-loadable encontra o módulo já carregado. Falha de prefetch é
// silenciosa: a rota carrega o chunk normalmente na navegação.
const PREFETCH_MAP = [
  {
    match: /^\/manager\/configuration\/medicalRecord\/fields/,
    load: () => import('@Components/configuration/MedicalRecord/Fields'),
  },
  {
    match: /^\/manager\/configuration\/medicalRecord/,
    load: () => import('@Components/configuration/MedicalRecord'),
  },
  {
    match: /^\/manager\/configuration/,
    load: () => import('@Pages/configuration'),
  },
  {
    match: /^\/manager/,
    load: () => import('@Pages/managerBusiness'),
  },
  {
    match: /^\/app/,
    load: () => import('@Pages/dashboard'),
  },
];

export const prefetchRouteChunks = (path) => {
  if (typeof path !== 'string' || !path) return;

  PREFETCH_MAP.forEach(({ match, load }) => {
    if (match.test(path)) {
      try {
        load().catch(() => {});
      } catch (e) {
        // Prefetch é melhoria progressiva; nunca deve quebrar o boot.
      }
    }
  });
};
